/**
 * The Finance report's query key, per half. The Wireframe Data admin page
 * invalidates it after saving inputs, so the report never shows totals from
 * before the edit.
 */
export const wireframeReportQueryKey = (timeframe: string) => ['admin-wireframe-report', timeframe];
